var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 250",
    style: {
      enableBackground: "new 0 0 306 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.9431,
    y1: 24.2499,
    x2: 271.0261,
    y2: 342.7016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE95C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7CD63"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M279.584,250H26.416c-13.918,0-24.837-11.857-24.389-26.405L8.167,24.047 C8.577,10.736,19.618,0,32.831,0h240.337c13.213,0,24.254,10.736,24.664,24.047l6.141,199.548 C304.421,238.143,293.503,250,279.584,250z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.2571,
    y1: 35.7153,
    x2: 219.6715,
    y2: 120.0387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F5B510"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    cx: 219.964,
    cy: 77.877,
    r: 42.163
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1375,
    y1: 38.6846,
    x2: 148.918,
    y2: 214.2916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#13AFED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#4645D7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_3_)",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 149.528,
    cy: 126.488,
    r: 86.806
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.1997,
    y1: 154.7624,
    x2: 83.9035,
    y2: 197.4201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F5B510"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    cx: 84.052,
    cy: 176.091,
    r: 21.329
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.8965,
    y1: 73.3991,
    x2: 148.9759,
    y2: 205.9556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#13AFED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#4645D7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    cx: 149.528,
    cy: 126.488,
    r: 77.877
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.6803,
    y1: 61.5756,
    x2: 188.3022,
    y2: 116.0341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F77F24"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M165.897,85.317c0,0,31.746-28.77,42.659-22.817s-14.881,53.571-14.881,53.571L165.897,85.317 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -1029.3536,
    y1: 63.5598,
    x2: -1029.7318,
    y2: 118.0182,
    gradientTransform: "matrix(-1 0 0 1 -916.2867 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F77F24"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M135.85,87.302c0,0-31.746-28.77-42.659-22.817c-10.913,5.952,14.881,53.571,14.881,53.571 L135.85,87.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBEA5"
    },
    d: "M173.833,87.302c0,0,17.857-15.873,24.802-9.921c6.944,5.952-5.952,30.754-5.952,30.754 L173.833,87.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBEA5"
    },
    d: "M129.19,91.27c0,0-18.656-19.309-26.786-13.889c-5.952,3.968,4.96,28.77,4.96,28.77L129.19,91.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403659"
    },
    d: "M208.556,62.5c-4.748-2.59-13.44,1.395-21.745,6.722c5.013-0.002,11.776,0.392,14.8,2.207 c3.265,1.959,4.811,9.936,5.486,15.16C211.101,75.574,213.305,65.091,208.556,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403659"
    },
    d: "M92.484,63.492c-3.77,3.878-1.596,13.649,1.305,23.08c1.344-4.829,3.54-11.238,6.1-13.664 c2.764-2.619,10.863-1.966,16.076-1.213C106.431,64.88,96.255,59.613,92.484,63.492z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9101,
    y1: 77.3824,
    x2: 149.1868,
    y2: 181.5468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F98D2A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M202.603,132.44c0,28.765-23.763,49.107-53.075,49.107s-53.075-20.342-53.075-49.107 s23.763-55.06,53.075-55.06S202.603,103.676,202.603,132.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F8FF"
    },
    d: "M88.516,141.865c0,0,13.889,39.683,61.508,39.683s61.508-39.683,61.508-39.683 s-22.817-6.944-45.635-1.984c-14.115,3.068-17.857,11.905-17.857,11.905s-5.919-10.095-15.873-11.905 C110.341,135.913,88.516,141.865,88.516,141.865z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#403659"
    },
    cx: 177.306,
    cy: 134.425,
    r: 6.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#403659"
    },
    cx: 122.742,
    cy: 133.433,
    r: 6.448
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403659"
    },
    d: "M148.04,151.786c0,0-10.683-6.088-7.325-8.004c3.357-1.916,13.686-1.534,13.978,0.755 S148.04,151.786,148.04,151.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F6F8FF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M117.782,132.44 c0,0,0.992-3.968,4.96-3.968"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F6F8FF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M172.345,133.433 c0,0,0.992-3.968,4.96-3.968"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#403659",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M159.521,157.427 c-1.37,1.125-3.122,1.8-5.033,1.8c-4.96,0-6.944-4.545-6.944-8.929"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#403659",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M135.639,157.427 c1.37,1.125,3.122,1.8,5.033,1.8c4.96,0,6.944-4.545,6.944-8.929"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.489,
    y1: 19.8415,
    x2: 38.3443,
    y2: 40.6744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 38.417,
    cy: 30.258,
    r: 10.417
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.7256,
    y1: 193.4528,
    x2: 266.4569,
    y2: 232.1424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    cx: 266.591,
    cy: 212.798,
    r: 19.345
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.4556,
    y1: 52.5795,
    x2: 37.3936,
    y2: 61.5078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    cx: 37.425,
    cy: 57.044,
    r: 4.464
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.2424,
    y1: 26.7858,
    x2: 63.1941,
    y2: 33.7301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    cx: 63.218,
    cy: 30.258,
    r: 3.472
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.6292,
    y1: 164.6827,
    x2: 266.5534,
    y2: 175.5951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    cx: 266.591,
    cy: 170.139,
    r: 5.456
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.9566,
    y1: 212.3017,
    x2: 223.9084,
    y2: 219.246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB13C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    style: {
      stopColor: "#F67622"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    cx: 223.933,
    cy: 215.774,
    r: 3.472
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstStep);
export default __webpack_public_path__ + "static/media/first_step.c1c1d4508170430328140cb07d6b0f6e.svg";
export { ForwardRef as ReactComponent };